
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import "../styles/footer/footer.css";

// const HoverIconLink = ({ href, icon, hoverIcon, alt, label }) => {
//     return (
//         <a href={href} className="hover-icon-link">
//             <div className="icon-wrapper">
//                 <img src={icon} alt={alt} className="icon default" />
//                 <img src={hoverIcon} alt={alt} className="icon hover" />
//                 <span className="tooltip">{label}</span>
//             </div>
//         </a>

//     );
// };
export default function Footer({ hideFooter = true }) {
    const { lang } = useParams();
    const { t } = useTranslation();

    return (
        <footer className="footer">
            {!hideFooter ? (
                <>
                    <div className="container">
                        <div className="contents">
                            <div className="content">
                                <div className="logo-built">
                                    <a href="/">
                                        <img
                                            src="/assets/MPTC-MRD-2023_Subtitle-Blue.png"
                                            alt="Logo"
                                            className="logo"
                                        />
                                    </a>
                                    <div className="built">
                                        <p>{t('creator')}</p>
                                        <a href="/">
                                            <img
                                                src="/assets/MPTC_Logo.png"
                                                alt="sub_logo"
                                                className="sub_logo"
                                            />
                                        </a>
                                    </div>
                                </div>

                            </div>
                            <div className="sub-content">
                                <a href="mailto:info@mptc.gov.kh" className="contact-link">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><g class="mail-outline"><g fill="currentColor" fill-rule="evenodd" class="Vector" clip-rule="evenodd"><path d="M6 5h12a4 4 0 0 1 4 4v7a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" /><path d="M3.643 6.986a1 1 0 0 1 1.372-.343l6.47 3.882a1 1 0 0 0 1.03 0l6.47-3.882a1 1 0 0 1 1.03 1.715l-6.472 3.882a3 3 0 0 1-3.086 0L3.984 8.358a1 1 0 0 1-.342-1.372Z" /></g></g></svg>
                                    <span>info@mptc.gov.kh</span>
                                </a>

                                <a
                                    href="https://maps.app.goo.gl/kcpYwQ4PgvxuP8Ph6"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="contact-link location-link "
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><path fill="currentColor" d="M12 14c2.206 0 4-1.794 4-4s-1.794-4-4-4s-4 1.794-4 4s1.794 4 4 4m0-6c1.103 0 2 .897 2 2s-.897 2-2 2s-2-.897-2-2s.897-2 2-2" /><path fill="currentColor" d="M11.42 21.814a1 1 0 0 0 1.16 0C12.884 21.599 20.029 16.44 20 10c0-4.411-3.589-8-8-8S4 5.589 4 9.995c-.029 6.445 7.116 11.604 7.42 11.819M12 4c3.309 0 6 2.691 6 6.005c.021 4.438-4.388 8.423-6 9.73c-1.611-1.308-6.021-5.294-6-9.735c0-3.309 2.691-6 6-6" /></svg>
                                    <span>
                                        {t('address')}
                                    </span>
                                </a>

                            </div>

                            {/* <div className="sub-content" >
                                {/* <a href="#about-us" className="info-plat">{t('about-us')}</a> */}
                            {/* 
                                <a href="#how-it-works" className="info-plat">{t('how-it-works')}</a>
                            </div> */}

                            <div className="sub-content">
                                <Link to={`/lang/${lang}/policy`} className="info-plat">
                                    {t('policy')}
                                </Link>
                                <Link to={`/lang/${lang}/term`} className="info-plat">
                                    {t('terms-of-use')}
                                </Link>
                                <a href="#how-it-works" className="info-plat">{t('how-it-works')}</a>


                            </div>

                        </div>

                    </div >

                    <div className="section">
                        <div className="section-container">
                            <div className="copyright-social-link">
                                <div className="copyright">
                                    &copy; {new Date().getFullYear()} {t('ministry')}
                                </div>


                                <div className="social-link">
                                    <a href={`/lang/${lang}/facebook`} className="social-icon">
                                        <img src="/assets/Facebook_icon.png" alt="facebook icon" />
                                        <span className="tooltip">Go to our Facebook</span>
                                    </a>

                                    <a href={`/lang/${lang}/telegram`} className="social-icon">
                                        <img src="/assets/Telegram_icon.png" alt="telegram icon" />
                                        <span className="tooltip">Go to our Telegram</span>
                                    </a>

                                    <a href={`/lang/${lang}/x`} className="social-icon">
                                        <img src="/assets/X_icon.png" alt="x icon" />
                                        <span className="tooltip">Go to our X</span>
                                    </a>

                                    <a href={`/lang/${lang}/linkedin`} className="social-icon">
                                        <img src="/assets/Linkin_icon.png" alt="linkedin icon" />
                                        <span className="tooltip">Go to our LinkedIn</span>
                                    </a>

                                    <a href={`/lang/${lang}/tiktok`} className="social-icon">
                                        <img src="/assets/Tiktok_icon.png" alt="tiktok icon" />
                                        <span className="tooltip">Go to our TikTok</span>
                                    </a>
                                </div>


                            </div>

                        </div>

                    </div >
                </>

            ) : (
                <div className="subFooter">
                    <div className="power">
                        <span> {t('creator')}</span>
                        <a
                            href="/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src="/assets/MPTC-MRD-2023_Subtitle-Blue.png" alt="MPTC Logo" className="logo" />
                        </a>
                    </div>
                </div >
            )
            }
        </footer >

    );
}